module.exports = __webpack_public_path__ + "assets/b3b06afa7906013d411ac04193907ae8.mp3";